import { PlusCircle, Trash } from '@phosphor-icons/react';
import { Columns, Column, LinkButton, Text, textVariants, Inline } from '@etg/wings';
import { price as priceUtil } from '@eti/utils';
import { css, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import Feature from '../Feature';

const columnStyles = css`
  text-align: end;
`;

interface PreSelectedExtraProductProps {
  isRemoved: boolean;
  isCheckedInBaggageAvailableInFare: boolean;
  productId: number;
  price: number;
  name: string;
  productsHandler: (productId: number) => void;
}

const PreSelectedProduct = ({
  isRemoved,
  isCheckedInBaggageAvailableInFare,
  productId,
  price,
  name,
  productsHandler,
}: PreSelectedExtraProductProps) => {
  const { t } = useTranslation();
  const isMobileDevice = window.matchMedia(mediaQueries.small.only).matches;
  const linkTitle = isRemoved
    ? t('YourSelectedTrip.Preselected.Product.ReAdd.Label')
    : t('YourSelectedTrip.Preselected.Product.Remove.Label');
  const linkIcon = isRemoved ? <PlusCircle size={20} /> : <Trash size={20} />;

  return (
    <Columns data-testid={`extra-productId-${productId}`}>
      <Column>
        <Feature isIncluded={!isRemoved} isPreSelectedProduct isStriked={isRemoved} label={name} />
      </Column>
      <Column className={columnStyles}>
        <Inline align="end">
          {!isRemoved && (
            <Text data-testid={`price-of-productId-${productId}`} variant={textVariants._14_BOLD}>
              {priceUtil.formatPrice(price)}
            </Text>
          )}
          {!isCheckedInBaggageAvailableInFare && (
            <LinkButton
              aria-label={isMobileDevice ? linkTitle : ''}
              data-testid={isRemoved ? `reAdd-product-${productId}` : `remove-product-${productId}`}
              onClick={() => productsHandler(productId)}
            >
              <Inline spacing={4}>
                {linkIcon} {!isMobileDevice && linkTitle}
              </Inline>
            </LinkButton>
          )}
        </Inline>
      </Column>
    </Columns>
  );
};

export default PreSelectedProduct;
